import apiClient from '@/services/rest-api-sms/apiClient'
const baseEndpoint = '/notification'

export const get = async (queryParam, serverRegion) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return response?.data
}

export const markAsRead = async (data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/mark-read`,
    data,
  })

  return response
}

export const getNotificationRule = async () => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/rule`,
  })

  return response?.data
}

export const patchNotificationRule = async (payload) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/rule`,
    data: payload,
  })

  return response?.data
}

export const createNotificationRule = async (payload) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/rule`,
    data: payload,
  })

  return response?.data
}

export const getNotificationType = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/type`,
    params: params,
  })

  return response?.data
}
